export const generalEs = {
  strTarefa: 'Tarea',
  strInsumo: 'Insumo',
  strQueProcura: '¿Qué buscas?',
  strCod: 'código',
  strMoeda: 'moneda',
  strContracts: 'Contratos por pagar',
  strTotal: 'Total',
  strContratado: 'Contratado',
  strPago: 'Pago',
  strLiberado: 'Liberado',
  strSaldo: 'Saldo',
  strSaldoAPagar: 'Saldo a pagar',
  strSelecionarProjeto: 'Proyecto',
  strSelecionarColigada: 'Seleccione la empresa',
  strSelectProjeto: 'Seleccione el proyecto',
  strColigadaProjetoObrigatorios: 'Empresa y Proyecto son obligatorios.',
  strSalvar: 'Guardar',
  strCancelar: 'Cancelar',
  strUsuarioSemPermissaoFuncionalidade: 'No se le permite acceder al Cockpit de tarea/insumo en la empresa',
  strNenhumRegistroEncontrado: 'No se encontraron registros.',
  strVerificandoPermissao: 'Comprobando permiso',
  strVejaMais: 'Ver más',
  strPlaceHolderMultiSelectTaskInput: 'Filtrar por grupo de costos',
  strQuantidade: 'Cantidad',
  strValor: 'Valor',
  strUnidade: 'unidad',
  strSaldoInsumo: 'Saldo = Presupuestado - (Peticione + Contratado)',
  strSaldoInsumoTarefa: 'Saldo = Presupuestado - (Peticione + Medido)',
  strMedido: 'Medido',
  strOrcado: 'Presupuestado',
  strApropriado: 'Apropiado',
  strPedido: 'Peticione',
  strPedidos: 'Peticiones',
  strEntregue: 'Entregado',
  strTarefas: 'Tareas',
  strInsumos: 'Insumos',
  strInputTaskLabelDisclaimer: 'Código de tarea o descripción',
  strPlanejado: 'Planificado',
  strCusto: 'Costo',
  strConfigHost: 'Es necesario definir la dirección del servidor en el archivo {0}, configuración actual {1}, esta configuración permitirá utilizar el cockpit solo en el servidor instalado.',
  strPlaceHolderInputTask: '¿Quieres ver tareas específicas? Introduzca aquí el código, nombre, descripción o partes del código, nombre o descripción.',
  strStatus: 'status',
  strTarefaFinalizada: 'de la tarea completada',
  strProjetoAtual: 'Tu proyecto actual',
  strUltimaImportacaoBackOffice: ' Última importación de movimientos desde BackOffice',
  strUltimoCalculoProjeto: 'Cálculo del último proyecto',
  strUsuario: 'Usuario',
  strTituloTotvs: 'PORTAL TOTVS CONSTRUCCIÓN OBRAS Y PROYECTOS',
  strTrocarProjeto: 'Cambiar proyecto',
  strSair: 'Salir',
  strPedidoExtra: 'orden extra',
  strMedicoes: 'medidas',
  strAtualizar: 'Actualizar',
  strCodTarefa: 'Código Tarea',
  strNome: 'Nombre',
  strDescricao: 'Descripción',
  strPortugues:'Português',
  strEspanhol:'Español',
  strIngles:'English',
  strTarefaNaoEncontrada:'Tarea no encontrada.'
};


